import { Link } from "react-router-dom";

const LOGO_LIGHT = "/logo-light.png";
const LOGO_DARK = "/logo-dark.png";

export default function Logo({ className = "", variant = "default" }) {
    const isLight = variant === "light";
    const src = isLight ? LOGO_DARK : LOGO_LIGHT;
    return (
        <Link to="/" data-testid="brand-logo" className={`inline-flex items-center group ${className}`}>
            <img
                src={src}
                alt="Boostez Vos Neurones — Le meilleur est en vous"
                className="h-14 sm:h-16 w-auto object-contain transition-transform duration-300 group-hover:scale-[1.03]"
                loading="eager"
            />
        </Link>
    );
}
